import { createTheme } from "@mui/material/styles";
import "./types"; // Import theme type augmentation

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "rgb(35, 65, 79)", // Top bar color
      light: "#62727B",
      dark: "#263238",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "rgb(221, 110, 45)", // Planning bar color
      light: "#FF8A50",
      dark: "#B33A00",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#fff",
      paper: "#F9F9F9",
    },
    info: {
      dark: "#1C7ED6",
      main: "#2196F3",
      light: "#D0E9FF",
    },
    text: {
      primary: "#1C1C1C",
      secondary: "#707070",
    },
    success: {
      dark: "#008D1F",
      main: "#c1eac4",
      light: "#D8F8D1",
    },
    warning: {
      dark: "#FF8C00",
      main: "#FFB74D",
      light: "#FFE0B2",
    },
    // Custom navbar palette for glass-style controls on dark backgrounds
    navbar: {
      glassBg: "rgba(255, 255, 255, 0.1)",
      glassHover: "rgba(255, 255, 255, 0.2)",
      inputBg: "rgba(0, 0, 0, 0.1)",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica Neue", Arial, sans-serif',
    htmlFontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    body1: {
      fontSize: "1.1rem",
    },
    body2: {
      fontSize: "0.8rem",
    },
    subtitle1: {
      fontSize: "16px",
      lineHeight: "28px",
      letterSpacing: "0.15px",
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: "0.875rem",
      lineHeight: "24px",
      letterSpacing: "0.17px",
      fontWeight: 600,
    },
    h6: {
      fontSize: "20px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          fontWeight: 600,
          fontFamily: '"Inter", "Roboto", "Helvetica Neue", Arial, sans-serif',
          fontSize: "14px",
          lineHeight: "24px",
          letterSpacing: "0.4px",
        },
      },
    },
    MuiDialog: {
      defaultProps: {
        fullWidth: true,
        maxWidth: "sm",
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "0.8125rem",
          maxWidth: 300,
          lineHeight: 1.5,
        },
      },
    },
  },
});
